export const FAN_ERROR_TEXT =
  "Looks like your fan profile hasn't been completely setup. Let's finish that step now!";
export const NO_TRACKS_HEADER = 'No matched tracks';
export const NO_MORE_TRACKS_TEXT =
  'Please drop us a line to request tracks in your favorite genres, check back later, or change your preferred genres to get more tracks.';
